var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { EventEmitter, OnChanges, OnInit, SimpleChanges, TemplateRef, } from "@angular/core";
import { ToasterService } from "angular2-toaster";
import { OperatorWatcher } from "app/interfaces/v3-jobs-response.entity";
import { ClevertapEventsService } from "app/services";
import { WatcherService } from "app/services/watcher.service";
import { BsModalService } from "ngx-bootstrap";
var WatcherManagerComponent = /** @class */ (function () {
    function WatcherManagerComponent(watcherService, modalService, toasterService) {
        this.watcherService = watcherService;
        this.modalService = modalService;
        this.toasterService = toasterService;
        this.onRefresh = new EventEmitter();
        this.operators = [];
    }
    Object.defineProperty(WatcherManagerComponent.prototype, "assignToEmail", {
        get: function () {
            var _this = this;
            if (this.operators.length === 0) {
                return false;
            }
            return this.operators.find(function (o) { return o.id === _this.assignTo; }).email;
        },
        enumerable: true,
        configurable: true
    });
    WatcherManagerComponent.prototype.ngOnChanges = function (changes) {
        this.assignTo = changes.watcher.currentValue
            ? changes.watcher.currentValue.id
            : "unassigned";
    };
    WatcherManagerComponent.prototype.ngOnInit = function () { };
    WatcherManagerComponent.prototype.openModal = function (template) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        this.template = template;
                        _a = this;
                        _c = (_b = [
                            {
                                email: "UNASSIGNED",
                                id: "unassigned",
                            }
                        ]).concat;
                        return [4 /*yield*/, this.watcherService.retrieveOperators().toPromise()];
                    case 1:
                        _a.operators = _c.apply(_b, [(_d.sent())]);
                        this.modalRef = this.modalService.show(template, {
                            class: "modal-lg",
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    WatcherManagerComponent.prototype.submit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.assignTo) return [3 /*break*/, 8];
                        if (!(this.assignTo === "unassigned")) return [3 /*break*/, 5];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.watcherService.deleteWatcher(this.jobOfferId).toPromise()];
                    case 2:
                        _a.sent();
                        this.toasterService.pop("success", "Success");
                        this.modalRef.hide();
                        ClevertapEventsService.emitEvent("jobOfferOwnerChanged", { owner: "unassigned", jobOfferId: this.jobOfferId });
                        return [3 /*break*/, 4];
                    case 3:
                        e_1 = _a.sent();
                        this.toasterService.pop("error", "Error");
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 8];
                    case 5:
                        _a.trys.push([5, 7, , 8]);
                        return [4 /*yield*/, this.watcherService
                                .setWatcher(this.jobOfferId, this.assignTo)
                                .toPromise()];
                    case 6:
                        _a.sent();
                        ClevertapEventsService.emitEvent("jobOfferOwnerChanged", { owner: this.assignTo, jobOfferId: this.jobOfferId });
                        this.toasterService.pop("success", "Success");
                        this.modalRef.hide();
                        return [3 /*break*/, 8];
                    case 7:
                        e_2 = _a.sent();
                        this.toasterService.pop("error", "Error");
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    return WatcherManagerComponent;
}());
export { WatcherManagerComponent };
